import { ChevronDown } from 'assets/icons';
import MenuButton from 'components/DropdownMenu/MenuButton';
import useText from 'hooks/useText';
import StatsCard from './StatsCard';
import { METRICS } from './statsFormat';

const BAR_HEIGHT = 120;

/**
 * The chart of the period, as in the prototype: a bar per day or per week,
 * the current one (or the last) in orange, « Record » when it beats all the
 * others; a day or a week to come only has a dash. The menu on its right
 * picks what it counts. `bars` are { key, label, value, current }.
 */
const TrendCard = ({ title, bars, metric, onMetric }) => {
  const { text } = useText('stats');
  const max = Math.max(1, ...bars.map((bar) => bar.value ?? 0));
  const lead = bars.find((bar) => bar.current);
  const record =
    lead?.value > 0 &&
    bars.every((bar) => bar === lead || (bar.value ?? 0) < lead.value);
  return (
    <StatsCard
      title={title}
      className="min-w-0 flex-1"
      aside={
        <MenuButton
          items={METRICS.map((key) => ({
            label: text(`metric_${key}`),
            className: key === metric ? 'font-semibold text-gray-900' : '',
            onClick: () => onMetric(key),
          }))}
          trigger={(toggle, open) => (
            <button
              type="button"
              aria-expanded={open}
              onClick={toggle}
              className="flex h-10 items-center gap-2 rounded-md border border-gray-200 bg-white px-3 text-sm text-gray-700 transition-colors hover:bg-gray-50"
            >
              {text(`metric_${metric}`)}
              <ChevronDown wh={16} color="#9CA3AF" />
            </button>
          )}
        />
      }
    >
      <div className="flex min-h-[188px] items-end gap-2 tab:gap-4">
        {bars.map((bar) => (
          <div
            key={bar.key}
            className="flex min-w-0 flex-1 flex-col items-center gap-1.5"
          >
            {bar.current && record && (
              <span className="rounded-full bg-yellow-500 px-2 py-0.5 text-xs font-medium leading-4 text-white">
                {text('record')}
              </span>
            )}
            <span
              className={`text-xs font-medium leading-4 ${bar.current ? 'text-gray-900' : 'text-gray-600'}`}
            >
              {bar.value ?? '–'}
            </span>
            {bar.value != null && (
              <div
                className={`w-full max-w-8 rounded-t-md transition-[height] duration-500 ${bar.current ? 'bg-yellow-500' : 'bg-gray-200'}`}
                style={{ height: (bar.value / max) * BAR_HEIGHT }}
              />
            )}
            <span
              className={`truncate text-xs leading-4 ${bar.current ? 'font-medium text-gray-900' : 'text-gray-400'}`}
            >
              {bar.label}
            </span>
          </div>
        ))}
      </div>
    </StatsCard>
  );
};

export default TrendCard;
